import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import Template from 'components/cases/listpage/inhouseSupport/Template'

const InhouseSupport: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta
        keyword={'DX戦略 組織開発 内製化支援'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/cases/inhouse-support/'}
        title="内製化支援 | 事例 | Aitria（アイトリア）"
        description="内製化支援のケーススタディを紹介します｜Aitria（アイトリア）はビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default InhouseSupport
